import { render, staticRenderFns } from "./ConfirmCopyingSyllabus.vue?vue&type=template&id=3b3dce43&"
import script from "./ConfirmCopyingSyllabus.vue?vue&type=script&lang=js&"
export * from "./ConfirmCopyingSyllabus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports